import { useEffect, useState } from 'react';

/**
 * A ticking clock for a server-provided deadline.
 *
 * Returns the current time, not a decision. The distinction matters: a client
 * may *display* that a hold looks lapsed, but it must never conclude that the
 * inventory is gone — the server owns that, and a browser with a wrong clock
 * would otherwise tell somebody their tickets had expired when they had not
 * (kickoff Section 26).
 */
export function useNowTicking(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}
